import React from "react";
import { Box } from "@mui/material";
import "../../assets/settings.scss";
import { useNavigate } from "react-router-dom";
import Button from "../button/Button";
import {
  accountRequestRevoked,
  backToHome,
  requestAccepted,
} from "../messages";
import { timerIcon } from "../images";
import Text from "../text/Text";
import CustomDivider from "../divider/Divider";

function RequestAccepted() {
  const navigate = useNavigate();

  return (
    <>
      <Box className="options-container">
        <Box className="request-accepted-wrapper" height="96vh" marginTop={0}>
          <Box
            className="module-container"
            minHeight="244px"
            textAlign="center"
          >
            <Box>
              <img
                src={timerIcon}
                height="54px"
                width="54px"
                style={{ marginBottom: "16px" }}
              />
              <Text className="default-text" size={22} font="bold">
                {requestAccepted}
              </Text>
              <Text className="grey-text" size={16} font="regular">
                {accountRequestRevoked}
              </Text>
            </Box>
            <CustomDivider sx={{ m: "30px -30px" }} />
            <Button
              fullWidth
              variant="contained"
              label={backToHome}
              onClick={() => navigate("/wallet")}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default RequestAccepted;
